module.exports = __webpack_public_path__ + "img/tab-5.9104c28a.png";